import React, { useContext, createContext, useState, useEffect } from "react";
import { message } from "antd";
import api from "../../../services/api";

const OperatorContext = createContext({});

export const OperatorProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(true);
  const [operadores, setOperadores] = useState([]);

  useEffect(() => {
    api
      .get("/pasta/users")
      .then(response => {
        const { data } = response;

        if (data && data.length) {
          setOperadores(
            data.map(operator => ({
              id: operator.id,
              name: operator.username
            }))
          );
        }
      })
      .catch(err => {
        console.error(err);
        message.error("Falha ao carregar a lista de operadores.");
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <OperatorContext.Provider
      value={{
        operadores,
        isLoading
      }}
    >
      {children}
    </OperatorContext.Provider>
  );
};

export const useOperators = () => useContext(OperatorContext);



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/use-operators.jsx